import { render, staticRenderFns } from "./ticketVersionSet.vue?vue&type=template&id=2210d945&"
import script from "./ticketVersionSet.vue?vue&type=script&lang=js&"
export * from "./ticketVersionSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports